module.exports = __webpack_public_path__ + "img/architecture-style-icon_6.bd39bcaf.png";